import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Single } from 'components/Page';
import moment from 'moment';
import config from './config';

/**
 * @description Prepare data for API
 * @params {Object} start_date, end_date, ...rest
 * @return {Object}
 */
const handlePrepareData = ({ passport_expiry, ...rest }) => ({
  ...rest,
  passport_expiry: moment(passport_expiry, 'YYYY-MM-DD')
    .format('YYYY-MM-DD')
});

const UserTravel = ({ objectId, permissions }) => (
  <Single
    canAdmin={permissions.CanAdminUsers()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.userTravelProfile,
      list: REDUCER_KEY.peopleData
    }}
    config={{
      ...config,
      parent: {
        id: objectId
      }
    }}
    onPrepareData={handlePrepareData}
    permissions={permissions}
  />
);

UserTravel.propTypes = {
  objectId: PropTypes.number,
  permissions: PropTypes.object.isRequired
};

UserTravel.defaultProps = {
  objectId: null
};

export default UserTravel;
